import { render, staticRenderFns } from "./IBANComponent.vue?vue&type=template&id=28a74fbc&scoped=true&"
import script from "./IBANComponent.vue?vue&type=script&lang=js&"
export * from "./IBANComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a74fbc",
  null
  
)

export default component.exports